<template>
    <div
      class="flex flex-row overflow-auto p-4 h-full bg-slate-25 dark:bg-slate-800"
    >
      <woot-wizard
        class="hidden md:block w-1/4"
        :global-config="globalConfig"
        :items="items"
      />
      <router-view />
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import globalConfigMixin from 'shared/mixins/globalConfigMixin';
  
  export default {
    mixins: [globalConfigMixin],
    computed: {
      ...mapGetters({
        globalConfig: 'globalConfig/get',
      }),
      items() {
        return this.$t('CAMPAIGN_MANAGER.CREATE_FLOW.WIZARD').map(item => ({
          ...item,
          body: this.useInstallationName(
            item.body,
            this.globalConfig.installationName
          ),
        }));
      },
    },
  };
  </script>